import { render, staticRenderFns } from "./SoilForm.vue?vue&type=template&id=1b0488eb&scoped=true&"
import script from "./SoilForm.vue?vue&type=script&lang=js&"
export * from "./SoilForm.vue?vue&type=script&lang=js&"
import style0 from "./SoilForm.vue?vue&type=style&index=0&id=1b0488eb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0488eb",
  null
  
)

export default component.exports